module.exports = __webpack_public_path__ + "img/racecourse-greyville-turf-1300.d0bec10e.svg";